const PakistanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_112109)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20.0008C0 27.5817 4.21789 34.1769 10.4348 37.569V2.43262C4.21789 5.82473 0 12.42 0 20.0008Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0003 0C16.5354 0 13.2765 0.881484 10.4351 2.4318V37.5681C13.2765 39.1185 16.5354 40 20.0003 40C31.0459 40 40.0003 31.0456 40.0003 20C40.0003 8.95437 31.0459 0 20.0003 0Z"
        fill="#496E2D"
      />
      <path
        d="M28.5508 23.3068C26.0206 25.135 22.4873 24.5659 20.6592 22.0358C18.8309 19.5055 19.4001 15.9723 21.9303 14.1441C22.7192 13.5741 23.6056 13.2372 24.5074 13.1201C22.7725 12.8606 20.9385 13.2516 19.4043 14.3601C16.2903 16.6102 15.5897 20.9587 17.8398 24.073C20.0899 27.1869 24.4385 27.8876 27.5527 25.6373C29.087 24.5287 30.034 22.9105 30.3322 21.1817C29.938 22.0009 29.3398 22.7367 28.5508 23.3068Z"
        fill="#F0F0F0"
      />
      <path
        d="M28.4427 13.043L29.868 14.579L31.7692 13.6984L30.7487 15.5284L32.1739 17.0645L30.118 16.6595L29.0975 18.4896L28.8474 16.4091L26.7915 16.0041L28.6928 15.1234L28.4427 13.043Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112109">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PakistanSvg;
